// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'generalSans', 'generalSans Fallback', system-ui, arial"},"className":"__className_2d3193","variable":"__variable_2d3193"};